import style from "./Lesson.module.css";
import React, { SyntheticEvent, useState } from "react";
import Card from "../../../../base/reusables/card/Card";
import MultModal from "../../../../base/mult-modal/MultModal";
import { formatDate } from "../../../../base/services/dateTime";
import { Id, lessonsWithReferencedObjects } from "../../types";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import editIcon from "../../../../base/assets/icons/pencil_hover.svg";
import editIconHover from "../../../../base/assets/icons/pencil_hover1.svg";
import { Grid } from "@mui/material";
import { textMaxLength } from "../../../../base/services/maxLength";
import { useTranslation } from "react-i18next";
import AppStore from "../../../../base/stores/AppStore";


const Edit = ({ show, url, isApproved }: { show: boolean; url: string; isApproved: boolean; }) => {
  if (!show) return null;
  const navigate = useNavigate(); 
  const baseEditIcon = (event: SyntheticEvent) => ((event.target as HTMLImageElement).src = editIcon);
  const changeEditIcon = (event: SyntheticEvent) => ((event.target as HTMLImageElement).src = editIconHover);

  const { t } = useTranslation();

  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        navigate(`${AppStore.lessonsRoute}${t("Lesson-edit-path")}/${url}`);
      }}
    >
      <img
        alt={t("Lesson-edit-lesson-header")}
        src={editIcon}
        className={isApproved ? style.edit_icon_lesson_approved : style.edit_icon}
        onMouseOver={changeEditIcon}
        onMouseLeave={baseEditIcon}
      />
    </button>
  );
};
const PublishDate = ({ lesson }: { lesson: lessonsWithReferencedObjects }) => {
  const { t } = useTranslation();
  return (
    <div className={style.lesson__date}>
      {lesson?.isApproved ? (
        lesson?.approvedDate && (
          <div>
            {t("Lesson-posted-at")} {formatDate(lesson?.approvedDate)}
          </div>
        )
      ) : (
        <div>
          {t("Lesson-last-update")}{" "}
          {lesson?.lastUpdate && formatDate(lesson?.lastUpdate)}
        </div>
      )}
    </div>
  );
};

const Part = ({ label, value }: { label: string; value: string }) => {
  return (
    <section className={style.descr__item}>
      <span />
      <div>
        <div className={style.descr__itemHead}>{label}</div>
        <div className={style.descr__itemContent}>{value}</div>
      </div>
    </section>
  );
};

interface LessonPropsDI {
  showDelete: boolean;
  showEdit: boolean;
  onDelete: (id: Id) => void;
  lesson: lessonsWithReferencedObjects;
}

const Lesson: React.FC<LessonPropsDI> = (props) => {
  const [deleteBoxOpen, setDeleteBoxOpen] = useState(false);
  const lesson = props.lesson;
  const { t } = useTranslation();

  const handleLessonDelete = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.stopPropagation();
    if (lesson.id) {
      setDeleteBoxOpen(true);
    }
  };

  const confirmDelete = () => {
    if (lesson.id) {
      props.onDelete(lesson.id);
      setDeleteBoxOpen(false);
    }
  };

  const abortDelete = () => {
    setDeleteBoxOpen(false);
  };

  return (
    <>
      <Card
        body={
          <>
            <header>
              <Grid container className={style.lesson__header}>
                <Grid item xs={12} sm={4} className={style.lesson__category} />{" "}
                {/* leaving this to take space on the right */}
                <Grid
                  item
                  xs={12}
                  sm={8}
                  className={style.lesson__header__leftItems}
                >
                  <PublishDate lesson={lesson} />
                  {props.showDelete && lesson.isApproved ? (
                    <div className={style.lesson__delete__wrapper}>
                      <span className={style.lesson__delete__border} />
                      {lesson?.id ? (
                        <button
                          aria-label={t("Lesson-delete")}
                          onClick={(e) => handleLessonDelete(e)}
                        />
                      ) : null}
                    </div>
                  ) : null}

                  {lesson.id && (
                    <Edit show={props.showEdit} url={lesson.url || "/"} isApproved={!!lesson.isApproved} />
                  )}
                </Grid>
              </Grid>
              <div
                className={style.lesson__title}
                title={
                  lesson.title.length > textMaxLength.lessonTitle
                    ? lesson.title
                    : ""
                }
              >
                {lesson.title}
              </div>
            </header>

            <article className={style.descr}>
              <Part
                label={t("Lesson-field")}
                value={lesson.field?.name || ""}
              />
              <Part
                label={t("Lesson-projectType-label")}
                value={lesson.projectTypeId?.name || ""}
              />
              <Part
                label={t("Lesson-step-label")}
                value={lesson.step?.name || ""}
              />
            </article>
          </>
        }
        lessonIsApproved={!lesson.isApproved ? true : undefined}
      />
      {deleteBoxOpen ? (
        <MultModal
          text={t("Shall-Lesson-remove")}
          firstFunc={confirmDelete}
          firstFuncText={t("Lesson-delete-yes")}
          secondFunc={abortDelete}
          secondFuncText={t("Lesson-delete-no")}
        />
      ) : null}
    </>
  );
};

export default Lesson;
